import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-section-body',
  templateUrl: 'section-body.component.html',
  styleUrl: './section-body.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class SectionBodyComponent {}
